module.exports = __webpack_public_path__ + "static/media/S (172).fd3860c6.jpg";